import { baseApi } from '@shared/api/baseApi';

/** A shop feature shown to customers as a product-style card. */
export interface ShopServiceDto {
  slug: string;
  name: string;
  description: string | null;
  category: { id: string; slug: string; name: string } | null;
  logoUrl: string;
}

export const shopServiceApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getShopServices: builder.query<ShopServiceDto[], void>({
      query: () => '/services',
      transformResponse: (response: { services: ShopServiceDto[] }) => response.services,
      providesTags: ['ShopService'],
    }),
  }),
});

export const { useGetShopServicesQuery } = shopServiceApi;
